<template>
  <div class="content content-full">
    <div class="page-navs bg-white">
      <div class="nav-scroller">
        <div class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100">
          <router-link class="nav-link" to="/account" :class="{ active: tab === 'account' }">
            {{ $t('account') }}
          </router-link>
          <router-link class="nav-link" to="/account/profile" :class="{ active: tab === 'profile' }">
            {{ $t('profile') }}
          </router-link>
          <router-link class="nav-link" to="/account/subscription" :class="{ active: tab === 'subscription' }">
            {{ $t('subscription') }}
          </router-link>
          <router-link class="nav-link" to="/account/validate" :class="{ active: tab === 'validate' }">
            {{ $t('account_verification_form') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="page-inner">
      <div v-if="tab === 'validate'">
        <div id="sumsub-websdk-container"></div>
      </div>
      <form @submit.prevent="saveAccount()" v-if="tab === 'account'" id="account-form">
        <div class="card-body">
          <div class="fw-bold h4 mt-2">General</div>
          <hr>
          <div class="form-group form-show-validation row">
            <label for="username" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('username') }}</label>
            <div class="col-lg-4 col-md-9 col-sm-8">
              <div class="select2-input">
                <input id="username" :value="user.username" type="text" class="form-control" readonly>
              </div>
            </div>
          </div>
          <div class="form-group form-show-validation row">
            <label for="email" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Email</label>
            <div class="col-lg-4 col-md-9 col-sm-8">
              <div class="select2-input">
                <input id="email" :value="user.email" type="email" class="form-control" :disabled="true">
              </div>
            </div>
          </div>
          <div class="form-group form-show-validation row">
            <label for="current-password" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('current_password') }}</label>
            <div class="col-lg-4 col-md-9 col-sm-8">
              <input id="current-password" type="password" class="form-control" v-model="currentPassword" name="current-password">
            </div>
          </div>
          <div class="form-group form-show-validation row">
            <label for="new-password" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('new_password') }}</label>
            <div class="col-lg-4 col-md-9 col-sm-8">
              <input id="new-password" type="password" class="form-control" v-model="newPassword" name="new-password">
            </div>
          </div>
          <div class="form-group form-show-validation row">
            <label for="new-password-2" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('confirm_new_password') }}</label>
            <div class="col-lg-4 col-md-9 col-sm-8">
              <input id="new-password-2" type="password" class="form-control" v-model="newPassword2" name="new-password2">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right"></label>
            <div class="col-lg-4 col-md-9 col-sm-8 custom-control custom-checkbox">
              <input
                v-model="user.newsletter"
                type="checkbox"
                class="custom-control-input"
                name="newsletter"
                id="newsletter"
              />
              <label class="custom-control-label label-break-spaces" for="newsletter" v-html="$t('I_agree_to_receive_emai')">
              </label>
            </div>
          </div>
          <div class="fw-bold h4 mt-2">{{ $t('royalty_payments') }}</div>
          <hr>
          <div class="form-group form-show-validation row">
            <label class="col-lg-3 col-md-3 col-sm-4 text-right m-0 pt-2">
              {{ $t('payment_method') }}
            </label>
            <div class="col-lg-4 col-md-5 col-sm-8">
              <div class="selectgroup w-100">
                <label class="selectgroup-item">
                  <input type="radio" name="value" value="100" class="selectgroup-input" :checked="paymentType === 'bank'" @click="paymentType = 'bank'">
                  <span class="selectgroup-button">{{ $t('bank_account') }}</span>
                </label>
                <label class="selectgroup-item">
                  <input type="radio" name="value" value="50" class="selectgroup-input" :checked="paymentType === 'payoneer'" @click="paymentType = 'payoneer'">
                  <span class="selectgroup-button">Payoneer</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-group form-show-validation row" v-if="paymentType === 'payoneer'">
            <label class="col-lg-3 col-md-3 col-sm-4 text-right m-0 pt-2">
              Payoneer Email
            </label>
            <div class="col-lg-4 col-md-5 col-sm-8">
              <input type="email" v-model="user.payoneer_account" class="form-control">
              <div class="mt-1 p-1">
                <a class="small mt-1" href="https://payouts.payoneer.com/partners/or.aspx?pid=YOYIZC74IO2s4KZQp7tgsw%3d%3d&BusinessLine=5&UsePurpose=3" target="_blank">{{ $t('create_payoneer') }}</a>
              </div>
            </div>
          </div>

          <div v-show="paymentType === 'bank'">
            <div class="form-group form-show-validation row">
              <label class="col-lg-3 col-md-3 col-sm-4 text-right m-0 pt-2">
                {{ $t('select_country_of_bank') }}
              </label>
              <div class="col-lg-4 col-md-5 col-sm-8">
                <div class="select2-input" v-if="user">
                  <Select2 v-model="activeCountry" :options="selectedCountry"></Select2>
                </div>
              </div>
            </div>
            <div class="form-group form-show-validation row" v-if="(paymentMethod === 'stripe') || (user.stripe_completed && user.stripe_id)">
              <label class="col-lg-3 col-md-3 col-sm-4 text-right m-0">
                <img src="/static/img/stripe-logo.png" alt="logo-stripe" class="logo-stripe">
              </label>
              <div class="col-lg-4 col-md-5 col-sm-8">
                <div class="border rounded p-0 mt-2 mb-2 mr-0 p-2 pl-3">
                  <a :href="`/v1/api/payment-onboard?user=${user._id}`" class="text-underline" v-if="!user.stripe_completed">
                    {{ $t('create') }}
                  </a>
                  <a href="javascript:void(0)" class="text-underline"  @click="manageStripe()" v-else>
                    {{ $t('manage') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-action">
          <div class="row">
            <div class="col-md-12 text-right">
              <router-link to="/dashboard" class="btn btn-default btn-border no-border" :disabled="saving">
                <i class="fa fa-chevron-left mr-1"></i> {{ $t('cancel') }}
              </router-link>
              <button class="btn btn-success" type="submit" :disabled="saving" v-if="!user.freeze">
                <i v-if="saving" class="fa fa-spinner fa-spin"></i>
                <span v-if="!saving">{{ $t('update') }}</span>
              </button>
              <button type="button" class="btn btn-danger" @click="validateUser()" v-if="!user.freeze">{{ $t('deactivate_user') }}</button>
            </div>
          </div>
        </div>
      </form>

      <form @submit.prevent="submitProfile()" v-if="tab === 'profile'" id="profile-form">
        <div class="card-body">
          <div class="form-group form-show-validation row">
            <label for="name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('name') }} <span class="required-label">*</span></label>
            <div class="col-lg-4 col-md-9 col-sm-8">
              <div class="select2-input">
                <input id="name" v-model="user.name" type="text" class="form-control">
              </div>
            </div>
          </div>
          <div class="form-group form-show-validation row">
            <label for="last_name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('last_name') }}</label>
            <div class="col-lg-4 col-md-9 col-sm-8">
              <div class="select2-input">
                <input id="last_name" v-model="user.last_name" type="text" class="form-control">
              </div>
            </div>
          </div>
          <div class="form-group form-show-validation row">
            <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('phone_number') }}</label>
            <div class="col-lg-4 col-md-9 col-sm-8" v-if="user && user._id">
              <VuePhoneNumberInput @update="onUpdatePhone" v-bind:default-country-code="defaultCountry" v-model="newPhoneNumber" />
            </div>
          </div>
          <div class="form-group form-show-validation row">
            <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('preferred_notification_medium') }}</label>
            <div class="col-lg-4 col-md-9 col-sm-8" v-if="user && user._id">
              <select class="form-control" v-model="user.preferred_medium">
                <option value="sms">SMS</option>
                <option value="whatsapp">WhatsApp</option>
              </select>
            </div>
          </div>
          <div class="form-group form-show-validation row">
            <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('profile_picture') }}</label>
            <div class="col-lg-4 col-md-9 col-sm-8">
              <div class="input-file input-file-image" v-if="user.profile_image">
                <img :src="user.profile_image" alt="" width="200" class="img-thumbnail"><br/>
                <button type="button" class="mt-2 btn btn-default" @click="replaceImage()">{{ $t('remove_image') }}</button>
              </div>
              <div class="input-file input-file-image" v-if="!user.profile_image">
                <croppa
                  :width="300"
                  :height="300"
                  :prevent-white-space="true"
                  v-model="myCroppa">
                </croppa>
                <div class="mt-sm">
                  <button class="btn btn-default btn-sm" type="button" @click="zoomOut()" :disabled="!hasFile">
                    <i class="fa fa-search-minus"></i>
                  </button>
                  <button class="btn btn-default btn-sm" type="button" @click="zoomIn()" :disabled="!hasFile">
                    <i class="fa fa-search-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-action">
          <div class="row">
            <div class="col-md-12 text-right">
              <router-link to="/dashboard" class="btn btn-default btn-border no-border" :disabled="saving">
                <i class="fa fa-chevron-left mr-1"></i> {{ $t('cancel') }}
              </router-link>
              <button class="btn btn-success" type="submit" :disabled="saving" v-if="!user.freeze">
                <i v-if="saving" class="fa fa-spinner fa-spin"></i>
                <span v-if="!saving">{{ $t('update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </form>

      <div class="" v-if="tab === 'subscription'">
        <div class="card-header">
          <strong v-if="!subscription.active">{{ $t('membership_not_active') }} <i class="fa fa-circle text-danger ml-1"></i></strong>
          <strong v-if="subscription.active">{{ $t('membership_is_active') }} <i class="fa fa-circle text-success ml-1"></i></strong>
        </div>
        <div class="card-body">
          <div class="h1 mb-0">
            <strong>Indiefy</strong> <span v-if="user.subscription && user.subscription.plan_name === 'indiefy_lite'" class="fw-thin">LITE</span><span v-if="user.subscription && user.subscription.plan_name !== 'indiefy_lite'" class="fw-thin">PRO</span>
          </div>
          <div class="mb-3">
            {{ $t('unlock_all_features') }}
          </div>

          <div v-if="subscriptionLoaded">
            <div v-if="!subscription.active || subscription.cancelled">
              <router-link tagName="button" class="btn btn-primary" to="/upgrade" v-if="!user.freeze">
                {{ $t('purchase') }}
              </router-link>
            </div>

            <div v-if="subscription.active && !subscription.cancelled">
              <div class="form-group form-show-validation row mt-5">
                <div class="col-lg-3 col-md-3 col-sm-4 mb-2">
                  <span class="text-muted fw-thin" v-if="subscription.plan === 'monthly'">{{ $t('billed_monthly') }}</span>
                  <span class="text-muted fw-thin" v-if="subscription.plan === 'yearly'">{{ $t('billed_yearly') }}</span>
                  <a :href="'/receipt/subscription/'+subscription._id" v-if="subscription.source !== 'free'" target="_blank">{{ $t('see_receipt') }}</a>
                </div>
                <!-- <div class="col-lg-4 col-md-9 col-sm-8">
                  <router-link tagName="button" class="btn btn-primary" to="/upgrade" v-if="!user.freeze && subscription.source !== 'free'">
                    {{ $t('change_plan') }}
                  </router-link>
                </div> -->
              </div>

              <div class="form-group form-show-validation row">
                <div class="col-lg-3 col-md-3 col-sm-4">
                  <span class="fw-bold">{{ $t('next_bill_date') }}</span>
                </div>
                <div class="col-lg-4 col-md-9 col-sm-8 fw-bold text-primary">
                  {{ moment.utc(subscription.expires).format('LL') }}
                </div>
                <div class="col-lg-5">&nbsp;</div>
                <div class="col-lg-8 mt-5" v-if="subscription.stripe_info">
                  <div class="h2">Subscription history</div>
                  <div class="card table-responsive">
                    <table class="table mb-0">
                      <thead>
                        <tr>
                          <th>{{ $t('amount') }}</th>
                          <th>{{ $t('date') }}</th>
                          <th>{{ $t('receipt') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(subs, index) in subscription.stripe_info" v-bind:key="`subs_${index}`">
                          <td>{{ currency.format(subs.amount) }}</td>
                          <td>{{ subs.created }}</td>
                          <td><a :href="subs.receipt_url" target="_blank">{{ $t('see_receipt') }}</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-lg-4" v-if="subscription.stripe_info">&nbsp;</div>
              </div>

              <!-- <div class="form-group form-show-validation row">
                <div class="col-lg-3 col-md-3 col-sm-4">
                  <span class="fw-bold h4">{{ $t('end_membership') }}</span>
                </div>
              </div>
               -->
              <hr class="mb-4"/>
              <div class="pb-4 pt-4 mb-4 mt-4"></div>
              <div class="form-group form-show-validation row mt-2 pt-2">
                <div class="col-lg-4 col-md-4 col-sm-4 mt-4">
                  <div class="mt-2 pt-2">
                    {{ $t('cancelling_details') }}<br/><br/>
                    <router-link to="/account/subscription/cancel" class="text-muted text-sm">
                      {{ $t('end_membership') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import moment from 'moment'
import User from '../services/user'
import Upload from '../services/upload'
import Distributions from '../services/distributions'
import Auth from '../services/auth'
import VuePhoneNumberInput from 'vue-phone-number-input'
import countries from '../data/countries'
import Select2 from './utils/Select2'
import snsWebSdk from '@sumsub/websdk'

export default {
  name: 'Account',
  data () {
    return {
      subscriptionLoaded: false,
      showPaypalInstructions: false,
      defaultCountry: 'US',
      newPhoneNumber: '',
      moment: moment,
      subscription: {},
      currentPassword: '',
      newPassword: '',
      newPassword2: '',
      myCroppa: {},
      user: {},
      tab: 'account',
      defaultImage: '/static/img/img-placeholder.jpg',
      saving: false,
      distributions: [],
      paymentType: 'bank',
      paymentMethod: '',
      selectedCountry: (
        () => _.map(_.clone(countries), elem => {
          return { id: elem.code, text: elem.name }
        }))(),
      activeCountry: '',
      payments_details: {
        full_name: '',
        account_number: '',
        swift_code: '',
        address: '',
        city: '',
        state: '',
        post_code: '',
        sv_name: '',
        sv_last_name: '',
        sv_province: '',
        sv_city: '',
        sv_phone_mobile: '',
        sv_phone_home: '',
        sv_email: '',
        sv_num_doc_identity: '',
        sv_bank_name: '',
        sv_type_account: '',
        sv_num_account: ''
      },
      hasNewPrice: false,
      currency: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    }
  },
  computed: {
    hasFile: function () {
      return this.myCroppa.getChosenFile && this.myCroppa.getChosenFile()
    }
  },
  methods: {
    launchWebSdk (accessToken) {
      this.validating = true

      let snsWebSdkInstance = snsWebSdk.init(accessToken, () => this.getNewAccessToken())
        .withConf({
          lang: this.$i18n.locale,
          email: this.user.email
        })
        .on('onError', (error) => {
          console.log('onError', error)
        })
        .onMessage((type, payload) => {
          // console.log('onMessage', type, payload, payload.reviewResult)

          if (type === 'idCheck.onApplicantLoaded') {
            this.user.applicant_id = payload.applicantId
          }

          if ((type === 'idCheck.applicantStatus' || type === 'idCheck.onApplicantStatusChanged') && payload.reviewResult && payload.reviewResult.reviewAnswer === 'GREEN') {
            setTimeout(() => {
              User.update({ identity_verified: 1, applicant_id: this.user.applicant_id }, () => {})
              this.user.identity_verified = 1
              this.validating = false
              this.$forceUpdate()
            }, 1000)
          } else if (this.user.applicant_id) {
            User.update({ applicant_id: this.user.applicant_id }, () => {})
          }
        })
        .build()

      snsWebSdkInstance.launch('#sumsub-websdk-container')
    },
    requestVerification: function () {
      User.createVerificationToken().then(response => {
        this.launchWebSdk(response.data.token)
      }).catch(error => {
        console.log('Error when requesting token', error)
      })
    },
    setPayment: function () {
      if (this.activeCountry) {
        let payoutMethods = {}
        _.each(_.clone(countries), elem => {
          if (this.activeCountry === elem.code) {
            payoutMethods = elem.payout_methods
          }
        })
        if (payoutMethods) {
          if (_.contains(payoutMethods, 'stripe')) {
            this.paymentMethod = 'stripe'
          } else if (_.contains(payoutMethods, 'wise')) {
            this.paymentMethod = 'wise'
          } else if (_.contains(payoutMethods, 'sendValu')) {
            this.paymentMethod = 'sendValu'
          } else {
            this.paymentMethod = ''
          }
        } else {
          this.paymentMethod = ''
        }
      }
    },
    cancelSubscriptionModal: function () {
      window.$(this.$refs.cancelSubscriptionModal).modal('show')
    },
    onUpdatePhone: function (ev) {
      this.user.phone_code = '+' + ev.countryCallingCode
    },
    cancelSubscription: function () {
      window.$(this.$refs.cancelSubscriptionModal).modal('hide')

      if (this.subscription.source === 'paypal') {
        this.showPaypalInstructions = true
      } else {
        this.subscription.cancelled = 1

        User.cancelSubscription().then(response => {
          this.$notify({ message: this.$t('subscription_cancelled') }, 'success', 'fa-check')
        })
      }

      User.sendChurnFeedback(this.reasons)
      this.reasons = {}
    },
    saveAccount: function () {
      if (this.currentPassword || this.newPassword || this.newPassword2) {
        if ((this.newPassword && !this.newPassword2) || (this.newPassword2 && !this.newPassword)) {
          return this.$notify({ message: this.$t('confirm_password') }, 'warning', 'fa-exclamation')
        }

        if (this.newPassword !== this.newPassword2) {
          return this.$notify({ message: this.$t('passwords_not_match') }, 'warning', 'fa-exclamation')
        }

        if (!this.currentPassword || !this.newPassword || !this.newPassword2) {
          return this.$notify({ message: this.$t('current_password_validation') }, 'warning', 'fa-exclamation')
        }

        if (this.currentPassword === this.newPassword || this.currentPassword === this.newPassword2) {
          return this.$notify({ message: this.$t('new_password_cannot_current') }, 'warning', 'fa-exclamation')
        }
      }

      const updateObject = {
        email: this.user.email,
        paypal_account: this.user.paypal_account,
        payoneer_account: this.user.payoneer_account,
        newsletter: this.user.newsletter,
        active_country: this.activeCountry
      }

      if (this.user.stripe_completed) {
        updateObject.payment_method = 'stripe'
      }

      if (this.newPassword) {
        updateObject.password = this.newPassword
      }

      if (this.currentPassword) {
        updateObject.current_password = this.currentPassword
      }

      this.saving = true

      User.update(updateObject).then(response => {
        this.saving = false
        _.extend(this.$user, response.data)
        this.$eventBus.$emit('updateUser', this.$user)
        this.$notify({ message: this.$t('account_updated') }, 'success', 'fa-check')
      }, error => {
        this.saving = false
        let message = error.response.data.name

        if (message === 'duplicated_email') {
          this.$notify({ message: this.$t('email_registered') }, 'warning', 'fa-exclamation')
        }

        if (message === 'invalid_current_password') {
          this.$notify({ message: this.$t('invalid_current_password') }, 'warning', 'fa-exclamation')
        }
      })
    },
    saveProfile: function () {
      const updateObject = {
        _id: this.user._id,
        name: this.user.name,
        last_name: this.user.last_name,
        profile_image: this.user.profile_image,
        profile_image_small: this.user.profile_image_small,
        preferred_medium: this.user.preferred_medium
      }

      if (this.newPhoneNumber) {
        if (this.newPhoneNumber.length && window.$('.input-tel.is-valid').length) {
          updateObject.phone_number = this.newPhoneNumber
          updateObject.phone_code = this.user.phone_code
        } else if (this.newPhoneNumber.length && !window.$('.input-tel.is-valid').length) {
          this.saving = false
          this.$notify({ message: this.$t('please_type_valid_number') }, 'warning', 'fa-exclamation')
          return
        }
      }

      User.update(updateObject).then(response => {
        this.saving = false
        _.extend(this.$user, response.data)
        this.$eventBus.$emit('updateUser', this.$user)
        this.$notify({ message: this.$t('profile_updated') }, 'success', 'fa-check')
      }, () => {
        this.saving = false
      })
    },
    submitProfile: function () {
      if (!this.user.name) {
        return this.$notify({ message: this.$t('type_name') }, 'warning', 'fa-exclamation')
      }

      this.saving = true

      if (this.hasFile) {
        this.uploadImage(() => {
          this.saveProfile()
        })
      } else {
        this.saveProfile()
      }
    },
    replaceImage: function () {
      // Remove Image
      Upload.removeImage(this.user.profile_image.split('/').pop(), 'profile-images').then(response => {
        this.user.profile_image = ''
        this.user.profile_image_small = ''

        if (this.user._id) {
          User.update({ profile_image: '', profile_image_small: '' }).then(() => {})
        }
      })
    },
    zoomIn: function () {
      this.myCroppa.zoomIn()
    },
    zoomOut: function () {
      this.myCroppa.zoomOut()
    },
    uploadImage: function (_callback) {
      this.myCroppa.generateBlob(
        blob => {
          Upload.uploadImage(blob, 'profile-images').then(response => {
            this.user.profile_image = response.data.full
            this.user.profile_image_small = response.data.small

            if (_callback) {
              _callback()
            }
          })
        },
        'image/jpeg',
        0.8
      ) // 80% compressed jpeg file
    },
    validateUser: function () {
      this.getProcessedDistros()
    },
    getProcessedDistros: function () {
      Distributions.getAll().then(response => {
        this.distributions = response.data
        this.processedDistros = _.filter(this.distributions, item => item.status > 0 && (item.status !== 6 && item.status !== 4)).length
        if (this.processedDistros) {
          window.swal({
            title: this.$t('deactivate_user_title'),
            text: this.$t('deactivate_user_text'),
            closeOnEsc: false,
            closeOnClickOutside: false,
            className: 'icon-modal',
            icon: 'warning',
            buttons: {
              close: {
                text: this.$t('close'),
                className: 'btn btn-dark',
                visible: true
              }
            }
          })
        } else {
          window.swal({
            title: this.$t('are_you_sure'),
            text: this.$t('deactivate_user_warning'),
            closeOnEsc: false,
            closeOnClickOutside: false,
            className: 'icon-modal',
            icon: 'warning',
            buttons: {
              remove: {
                text: this.$t('deactivate'),
                className: 'btn btn-danger',
                visible: true
              }
            }
          }).then((remove) => {
            if (remove) {
              User.deactivateUser().then((response) => {
                this.$user = {}
                this.$eventBus.$emit('updateUser', null)

                Auth.logout().then((response) => {
                  this.$router.push('/')
                })
              })
            }
          })
        }
      })
    },
    manageStripe: function () {
      User.getStripeLogin(this.user.stripe_id).then(response => {
        window.open(response.data.url)
      })
    }
  },
  watch: {
    $route: function (from, to) {
      if (this.$route.name === 'Profile') {
        this.tab = 'profile'
      }

      if (this.$route.name === 'Account') {
        this.tab = 'account'
      }

      if (this.$route.name === 'Subscription') {
        this.tab = 'subscription'
      }

      if (this.$route.name === 'Validate') {
        this.tab = 'validate'
        this.requestVerification()
      }
    },
    'activeCountry': function () {
      this.setPayment()
    }
  },
  created: function () {
    this.user = this.$user
    this.activeCountry = (this.user.active_country) ? this.user.active_country : this.user.country
    this.payments_details = (this.user.payments_details) ? this.user.payments_details : this.payments_details

    if (this.user.country) {
      this.defaultCountry = this.user.country
    }

    if (!this.user.newsletter && this.user.newsletter !== 0) {
      this.user.newsletter = 1
    }

    this.newPhoneNumber = this.user.phone_number

    if (this.$route.name === 'Profile') {
      this.tab = 'profile'
    }

    if (this.$route.name === 'Account') {
      this.tab = 'account'
    }

    if (this.$route.name === 'Subscription') {
      this.tab = 'subscription'
    }

    if (this.$route.name === 'Validate') {
      this.tab = 'validate'
      this.requestVerification()
    }

    if (this.user.subscription) {
      User.getSubscription().then(response => {
        this.subscription = response.data
        this.subscriptionLoaded = true
      })
      User.getUserHasNewPricing().then(response => {
        this.hasNewPrice = response.data.show_new_price
      })
    } else {
      this.subscriptionLoaded = true
    }
  },
  mounted: function () {
    if (this.$route.query.stripe_created) {
      this.$notify({ message: this.$t('stripe_created_sucess') }, 'success', 'fa-check')
    }
  },
  components: {
    VuePhoneNumberInput,
    Select2
  }
}
</script>
<style lang="scss" scoped>
.list-reason {
  li {
    margin-bottom: 10px;

    input {
      position: relative;
      top: 2px;
    }
  }
}

textarea {
  resize: none;
}

.logo-stripe {
  max-width: 85px;
}
</style>



// WEBPACK FOOTER //
// src/components/Account.vue